<section class="animate-fadein animate-duration-300 animate-ease-in mx-auto min-h-[75vh] lg:min-h-screen flex flex-col items-center justify-center p-6 text-center">
    <div class="w-24 h-24 rounded-full bg-primary-100 dark:bg-primary-950 flex items-center justify-center mb-6">
        <i class="pi pi-exclamation-triangle text-primary-500 text-5xl"></i>
    </div>
    <h1 class="text-4xl font-bold text-surface-900 dark:text-surface-0 tracking-tight">404 - Página Não Encontrada</h1>
    <p class="text-surface-600 dark:text-surface-400 mt-3 max-w-md text-lg">A página que você está procurando não existe ou foi movida.</p>
    <div class="mt-8">
        <a routerLink="/" pButton label="Voltar para o Início" icon="pi pi-arrow-left"></a>
    </div>
</section>
<button class="layout-config-button config-link" (click)="layoutService.toggleConfigSidebar()">
    <i class="pi pi-cog"></i>
</button>
<app-configurator simple />
